const Pricing = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      
      {/* Hero Section with Blue Background */}
      <section className="pt-36 pb-20 lg:pt-40 lg:pb-32 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700">
        <div className="max-w-[1330px] mx-auto px-4 sm:px-6 lg:px-8 text-center">
          
          <h1 className="text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
            Submit The Form To Unlock{' '}
            <span className="block mt-2">Personalized Pricing</span>
          </h1>
          
          <div className="flex justify-center mt-8">
            <div className="w-20 h-20 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center">
              <svg className="w-10 h-10 text-white" fill="currentColor" viewBox="0 0 24 24">
                <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/>
              </svg>
            </div>
          </div>

        </div>
      </section>

      {/* Form Section */}
      <section className="py-16 lg:py-20">
        <div className="max-w-[1330px] mx-auto px-4 sm:px-6 lg:px-8">
          
          <div className="flex flex-col lg:flex-row gap-8 items-stretch">
            
            {/* Left Side - Image (30%) */}
            <div className="lg:w-[30%] flex items-stretch">
              <img 
                src="/billing1.avif" 
                alt="Medical Professional" 
                className="w-full h-full object-cover rounded-2xl"
              />
            </div>

            {/* Right Side - Form (70%) */}
            <div className="lg:w-[70%]">
              <form className="space-y-4 h-full flex flex-col justify-center">
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <input
                    type="text"
                    placeholder="Enter Your First Name"
                    className="w-full px-4 py-3 bg-gray-100 border-0 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-700"
                  />
                  <input
                    type="text"
                    placeholder="Enter Your Last Name"
                    className="w-full px-4 py-3 bg-gray-100 border-0 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-700"
                  />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <input
                    type="email"
                    placeholder="Email Address"
                    className="w-full px-4 py-3 bg-gray-100 border-0 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-700"
                  />
                  <input
                    type="tel"
                    placeholder="Mobile Number"
                    className="w-full px-4 py-3 bg-gray-100 border-0 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-700"
                  />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <input
                    type="text"
                    placeholder="Practice Name"
                    className="w-full px-4 py-3 bg-gray-100 border-0 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-700"
                  />
                  <select className="w-full px-4 py-3 bg-gray-100 border-0 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-500">
                    <option>- Select Number of Physicians -</option>
                    <option>1-5 Physicians</option>
                    <option>6-10 Physicians</option>
                    <option>11-20 Physicians</option>
                    <option>20+ Physicians</option>
                  </select>
                </div>

                <textarea
                  placeholder="Enter your Message"
                  rows="5"
                  className="w-full px-4 py-3 bg-gray-100 border-0 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none text-gray-700"
                ></textarea>

                <div>
                  <button
                    type="submit"
                    className="bg-blue-800 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-lg transition-colors shadow-lg"
                  >
                    Submit
                  </button>
                </div>

              </form>
            </div>

          </div>

        </div>
      </section>

    </div>
  );
};

export default Pricing;
